"use strict";

import toastr from "toastr";
import "blueimp-file-upload";

export default {
  init(selector, target, resetForm = false) {
    const labelFileUpload = document.querySelector(
      "label[for=fileupload] span"
    );

    $(selector).fileupload({
      dataType: "json",
      add: function (e, data) {
        $(".ibox-content").toggleClass("sk-loading");
        data.submit();
      },
      done: function (e, data) {
        const response = data.result;
        if (!response.error) {
          const file = response.data;
          const thumbnail = document.querySelector("#thumbnail");

          if (resetForm) {
            labelFileUpload.innerText = "Dosya Seçin";
            if (thumbnail) {
              thumbnail.setAttribute(
                "src",
                "/dist/static/assets/admin/no-image.png"
              );
            }
          } else {
            labelFileUpload.innerText = file.name;
            if (thumbnail) {
              thumbnail.setAttribute("src", file.thumbnail);
            }
          }

          toastr["success"](response.message);

          $(target).val(file.name);
        } else {
          toastr["error"](response.message);
          $(target).val(null);
        }

        $(".ibox-content").toggleClass("sk-loading");
      },
    });
  },
};
